import { Box, Flex } from 'reflexbox';
import styled, { keyframes } from 'styled-components';

import { tokens } from '@treams/treams-ui';

const ROW_COUNT = 8;
const CELL_WIDTHS = [
	[30, 45, 15],
	[25, 35, 30],
	[40, 25, 20],
	[20, 50, 18],
	[35, 30, 25],
	[28, 40, 22],
	[45, 20, 25],
	[22, 38, 28],
];

const scrollUp = keyframes`
	from { transform: translateY(0); }
	to { transform: translateY(-50%); }
`;

const shimmer = keyframes`
	0%, 100% { opacity: 0.5; }
	50% { opacity: 1; }
`;

const Viewport = styled(Box)`
	height: 220px;
	overflow: hidden;
	mask-image: linear-gradient(to bottom, transparent, black 20%, black 80%, transparent);
	-webkit-mask-image: linear-gradient(to bottom, transparent, black 20%, black 80%, transparent);
`;

const Track = styled(Box)`
	animation: ${scrollUp} 6s linear infinite;
	will-change: transform;
`;

const Row = styled(Flex)<{ index: number }>`
	animation: ${shimmer} 1.8s ease-in-out infinite;
	animation-delay: ${(props) => props.index * 0.15}s;
`;

const Cell = styled(Box)<{ width: number }>`
	height: 10px;
	width: ${(props) => props.width}%;
	border-radius: 5px;
	background: ${tokens.surface.secondary};
`;

export function ConversationRevealProcessingRows() {
	const rows = [...CELL_WIDTHS, ...CELL_WIDTHS];

	return (
		<Viewport aria-hidden="true">
			<Track>
				{rows.map((widths, index) => (
					<Row key={index} index={index % ROW_COUNT} py={2} px={3} style={{ gap: 12 }}>
						{widths.map((width, cellIndex) => (
							<Cell key={cellIndex} width={width} />
						))}
					</Row>
				))}
			</Track>
		</Viewport>
	);
}
